import { api } from "../../apiendpoints/index";
import axios from "../../axiosMiddleware";

// User
export const AddNewTicket = async (formData) => {
  return axios.post(`${api.Ticket.savetickit}`, formData);
};

export const GetUserTickets = async (payload) => {
  return axios.post(
    `${api.Ticket.Gettickit}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};

export const BulkApproveTickets = async (ticketIds, actionById) => {
  return axios.post(
    `${api.Ticket.BULK_APPROVE_TICKETS}?ActionById=${actionById}`,
    ticketIds
  );
};


export const SendTicketMessage = async (payload) => {
  return axios.post(
    `${api.Ticket.sendMessage}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );
};

export const GetTicketMessages = async (ticketId) => {
  return axios.get(
    `${api.Ticket.getMessages}/${ticketId}/messages`
  );
};

export const GetApplications = async () => {
  return axios.get(`${api.Ticket.GET_ALL}`);
};

export const GetModulesByAppId = async (applicationId) => {
  return axios.get(`${api.Ticket.GET_MODULES}?id=${applicationId}`);
};

export const GetSubModulesByModId = async (moduleId) => {
  return axios.get(`${api.Ticket.GET_SUBMODULES}?id=${moduleId}`);
};


export const SendStatuschange = async (requestData) => {

  const payload = {
    data: requestData.data
  };

  return axios.post(api.Ticket.SendStatuschange, payload);
};

export const approveTicket = (
  ticketId,
  assignedToId = null,
  action = "Approve",
  actionById = null,
  actionReason = "",
  approvedCompletionDate = null
) => {
  return axios.post(api.Ticket.ApproveOrDenyTicketViaMail, null, {
    params: {
      Id: ticketId,
      IsApproved: action === "Approve",
      Action: action,
      AssignedToId: assignedToId,
      ActionById: actionById,
      ActionReason: actionReason,
      ApprovedCompletionDate: approvedCompletionDate
        ? new Date(approvedCompletionDate).toISOString()
        : null,
    },
  });
};

export const getTicketHistory = async (ticketId) => {
  try {
    const response = await axios.post(
      `${api.Ticket.GetReopenTicketByID}?id=${ticketId}`
    );

    return response.data;
  } catch (error) {
    console.error("History API error:", error);
    return [];
  }
};

export const reassignTicket = async (
  ticketId,
  newAssigneeId,
  userId,
  recordType = "ticket"
) => {
  return axios.post(api.Ticket.ReassignTicket, {
    TicketId: ticketId,
    NewAssignedToId: newAssigneeId,
    UserId: userId,
    RecordType: recordType,
  });
};

export const GetAllTickets = async () => {
  return axios.get(api.Ticket.GetAllTickets);
};

export const forwardTicketRequest = async (
  ticketId,
  forwardedToId = null,
  extra = {}
) => {
  return axios.post(api.Ticket.ForwardTicketRequest, {
    ticketId,
    forwardedToId,
    forwardType: extra.forwardType || "Employee",
    forwardedToDepartmentId: extra.forwardedToDepartmentId || null,
  });
};

export const GetDepartmentRequestTypes = async (departmentId) => {
  if (!departmentId) {
    return {
      status: 200,
      data: [],
    };
  }

  return axios.get(
    api.Ticket.GET_DEPARTMENT_REQUEST_TYPES,
    {
      params: {
        departmentId: departmentId,
      },
    }
  );
};

export const GetTicketTypes = async () => {
  return axios.get(api.Ticket.GET_TICKET_TYPES);
};